module.exports = __webpack_public_path__ + "static/media/plane.obj.03d601ca.jpg";